export function removeLoading() {
  const loadingDiv: HTMLDivElement | null = document.querySelector("div.loading_container");
  const root: HTMLDivElement | null = document.querySelector("div#root");

  loadingDiv?.classList.add("loading_container--hide");
  loadingDiv?.classList.remove("loading_container--show");
  root?.classList.remove("root--hide");
}
